import React from "react";
import { Menu } from "antd";
import { NavLink, useRouteMatch } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import propTypes from "prop-types";
import SubMenu from "antd/lib/menu/SubMenu";
import "./style/menuStyle.scss";
import menuJson from "./json/menuList.json";
import { useSignOutGeneral } from "../hooks/generalFunction";
import { useAdminGroups } from "../hooks/useAdminGroups";

function MenuItems({ darkMode, toggleCollapsed, topMenu, events }) {
  const { path } = useRouteMatch();
  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split("/");

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu
      ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : "dashboard"}`]
      : []
  );

  const onOpenChange = (keys) => {
    setOpenKeys(
      keys[keys.length - 1] !== "recharts"
        ? [keys.length && keys[keys.length - 1]]
        : keys
    );
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  // scroll to top when clicking on a menu item
  const scrollToTop = (path) => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 300);
  };

  const signOut = useSignOutGeneral();
  const { hasGroup } = useAdminGroups();
  // noAdminFallback opts a specific item out of the usual "admin sees everything" rule —
  // contract templates are gated by their own standalone group, with no admin superuser
  // fallback anywhere (backend guard included), so showing the link to a plain admin would
  // just lead to a dead end.
  const visibleMenuItems = menuJson.filter(
    (item) => !item.requiresGroup || hasGroup(item.requiresGroup) || (!item.noAdminFallback && hasGroup("admin"))
  );

  const SignOut = async (e) => {
    //check if e preventDefault is valid
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    //logout aws session
    signOut();
  };

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? "inline" : "horizontal"}
      theme={darkMode && "dark"}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1
              ? "home"
              : mainPathSplit.length === 2
                ? mainPathSplit[1]
                : mainPathSplit[2]
            }`
          ]
          : []
      }
      defaultOpenKeys={
        !topMenu
          ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : "dashboard"}`]
          : []
      }
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}>
      {/* Menu begins here */}
      {visibleMenuItems.map((item) =>
        //check if item has sub
        item.sub.length > 0 ? (
          <SubMenu
            key={item.key}
            icon={!topMenu && <FeatherIcon icon={item.icon} />}
            title={item.label}>
            {item.sub.map((subItem) => (
              <Menu.Item key={subItem.key}>
                <NavLink
                  onClick={() => {
                    toggleCollapsed();
                    scrollToTop(`${path}/${subItem.path}`);
                  }}
                  to={`${path}/${subItem.path}`}>
                  {subItem.label}
                </NavLink>
              </Menu.Item>
            ))}
          </SubMenu>
        ) : (
          <Menu.Item
            icon={
              !topMenu && (
                <NavLink
                  className="menuItem-iocn"
                  to={item.path}
                  onClick={() => {
                    toggleCollapsed();
                    scrollToTop(item.path);
                  }}>
                  <FeatherIcon icon={item.icon} />
                </NavLink>
              )
            }
            key={item.key}>
            <NavLink
              onClick={() => {
                toggleCollapsed();
                scrollToTop(item.path);
              }}
              to={item.path}>
              {item.label}
            </NavLink>
          </Menu.Item>
        )
      )}
      <Menu.Item
        className="menuItem-iocn"
        onClick={SignOut}
        style={{background: '#f2efef'}}
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to="#">
              <FeatherIcon icon="log-out" />
            </NavLink>
          )
        }
        key="logout">
        <NavLink to="#">Sign Out</NavLink>
      </Menu.Item>
    </Menu>
  );
}

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
  events: propTypes.object
};

export default MenuItems;
